import React, { useEffect, useState } from "react";
import { SubHeader } from "../components/general/Header";
import { MdDelete } from "react-icons/md";
import axiosInstance from "../api/axios";
import Nodatafound from "../Images/Nodatafound.gif";
import Empty from "../components/animation/Empty";

const Notification = () => {
  const [isLoading, setIsloading] = useState();
  const [notificationData, setNotificationData] = useState();
  const getNotification = async () => {
    setIsloading(true);
    try {
      const url = "/account/notification/";
      const response = await axiosInstance.get(url);
      if (response?.status === 200) {
        await setNotificationData(response?.data);
        console.log("notification", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    getNotification();
  }, []);

  return (
    <div className="w-screen min-h-screen flex  bg-page flex-col md:items-center ">
      <main className="space-y-5  md:w-1/3  bg-[#f1f8f7] min-h-screen  p-5 ">
        <SubHeader title={"Notification"} />

        {notificationData.length === 0 && !isLoading ? (
          <div className="h-screen flex justify-center items-center">
            <Empty
              src={Nodatafound}
              writeup={"No notification at this time "}
            />
          </div>
        ) : (
          <ul className="space-y-3">
            <li className="space-y-4 bg-secondary/5  p-3 rounded-lg">
              <div className="text-sm border-b py-3 space-y-2">
                <p className=" bg-secondary/10 rounded-md px-2 py-1 w-fit ">
                  Hello
                </p>
                <p className="opacity-60">how are you</p>
              </div>
              <div className="text-sm flex items-center justify-between">
                <p className="opacity-60 ">1/2/2024</p>
                <button className="flex items-center text-sm text-red-600">
                  <MdDelete /> Delete
                </button>
              </div>
            </li>
          </ul>
        )}
      </main>
    </div>
  );
};

export default Notification;
